import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { School } from 'lucide-react';
import { toast } from 'sonner';
import { ResetPasswordForm } from '@/components/auth/ResetPasswordForm';
import { supabase } from '@/lib/supabase';

export default function ResetPasswordPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const accessToken = params.get('access_token') || '';
    const refreshToken = params.get('refresh_token') || '';
    const expiresIn = parseInt(params.get('expires_in') || '3600');
    
    if (!hash || !accessToken || !refreshToken) {
      navigate('/auth/login'); 
      return;
    }
    
    // Set the session
    const setSession = async () => {
      try {
        const { error } = await supabase.auth.setSession({
          access_token: accessToken,
          refresh_token: refreshToken,
          expires_in: expiresIn
        });

        if (error) throw error;
      } catch (error) {
        console.error('Error setting session:', error);
        toast.error('Failed to initialize session');
        navigate('/auth/login');
      }
    };

    setSession();
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gradient-to-b from-blue-50 to-blue-100">
      <div className="w-full max-w-md space-y-8">
        <div className="flex flex-col items-center">
          <School className="h-12 w-12 text-primary" />
          <h1 className="mt-4 text-3xl font-bold">School Manager</h1>
          <p className="mt-2 text-muted-foreground">
            Set your new password
          </p>
        </div>
        <ResetPasswordForm />
      </div>
    </div>
  );
}